import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreInformation: {
		id: 'issue-field-description.more-information',
		defaultMessage: 'More information about {label}',
		description: 'Aria label, More information about',
	},
});
